/* eslint-disable no-param-reassign,no-underscore-dangle,class-methods-use-this */
import { Nullable } from 'types';
import type { IUBendaConfig } from './config';

export default class CookieConsent {
  config: IUBendaConfig;

  url: string;

  iub: Nullable<{
    csConfiguration: IUBendaConfig;
  }>;

  isScriptRunning: boolean;

  constructor(config: IUBendaConfig, url: string) {
    this.config = config;
    this.url = url;
    this.iub = null;
    this.isScriptRunning = false;
  }

  /**
   * Runs Iubenda script
   * @param windowObj
   * @param documentObj
   */
  run(windowObj: Window = window, documentObj: Document = document): void {
    this.isScriptRunning = true;
    windowObj._iub = windowObj._iub || [];
    this.iub = windowObj._iub;
    windowObj._iub.csConfiguration = this.config;

    const loader = () => {
      const script = documentObj.createElement('script');
      const tag = documentObj.getElementsByTagName('script')[0];
      script.src = this.url;

      if (tag.parentNode) {
        tag.parentNode.insertBefore(script, tag);
      }
    };

    if (windowObj.addEventListener) {
      windowObj.addEventListener('load', loader, false);
    } else if (windowObj.attachEvent) {
      windowObj.attachEvent('onload', loader);
    } else {
      windowObj.onload = loader;
    }
  }

  /**
   * Throws and error for methods that has been called after run method
   * @param methodName
   */
  throwErrorForWrongCallingOrder(methodName: string): void {
    throw Error(`'${methodName}' should be called before the 'run' method.`);
  }

  /**
   * Sets the consent callback function in the Iubenda configuration
   * @param callback
   * @returns {CookieConsent}
   */
  onConsentGiven(callback: () => void): CookieConsent {
    if (this.isScriptRunning) {
      this.throwErrorForWrongCallingOrder('setConsentGivenCallback');
    } else {
      this.config.callback.onConsentGiven = callback;
    }

    return this;
  }

  /**
   * Sets a callback function for rejected consents in the Iubenda configuration
   * @param callback
   * @returns {CookieConsent}
   */
  onConsentRejected(callback: () => void): CookieConsent {
    if (this.isScriptRunning) {
      this.throwErrorForWrongCallingOrder('setConsentRejectedCallback');
    } else {
      this.config.callback.onConsentRejected = callback;
    }

    return this;
  }

  // This method is not used after setting the option banner.rejectButtonDisplay: true
  // /**
  //  * Checks if the consent has been set
  //  * @returns boolean
  //  */
  // get isConsentGiven(): boolean {
  //   return this.iub ? this.iub.csConfiguration.api.isConsentGiven() : false;
  // }
}
